import { WooCommerceProduct } from "@/types/woocommerce";

const API_URL = process.env.NEXT_PUBLIC_WOOCOMMERCE_API_URL || "https://tehnolink.net/wp-json/wc/v3";
const CONSUMER_KEY = process.env.NEXT_PUBLIC_WOOCOMMERCE_CONSUMER_KEY || "ck_50493b2d57ff0f3895567b202c207e1bd36dbac7";
const CONSUMER_SECRET = process.env.NEXT_PUBLIC_WOOCOMMERCE_CONSUMER_SECRET || "cs_8dd00d08612e5c652cee2b27aeaded98e032d756";

function getAuthHeaders(): HeadersInit {
  const pair = `${CONSUMER_KEY}:${CONSUMER_SECRET}`;
  const encoded = typeof window !== "undefined" 
    ? btoa(pair)
    : Buffer.from(pair).toString("base64");
  
  return {
    "Authorization": `Basic ${encoded}`,
    "Content-Type": "application/json",
  };
}

export async function fetchProducts(params?: Record<string, string | number | boolean>): Promise<WooCommerceProduct[]> {
  const queryParams = new URLSearchParams();
  
  // Add auth credentials as query parameters
  queryParams.append('consumer_key', CONSUMER_KEY);
  queryParams.append('consumer_secret', CONSUMER_SECRET);
  
  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== "") {
        queryParams.append(key, String(value));
      }
    });
  }
  
  const url = `${API_URL}/products?${queryParams.toString()}`;
  
  const response = await fetch(url, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  
  if (!response.ok) {
    throw new Error(`Failed to fetch products: ${response.statusText}`);
  }
  
  return response.json();
}

export async function fetchCategories(): Promise<{ id: number; name: string; slug: string }[]> {
  const queryParams = new URLSearchParams();
  queryParams.append('consumer_key', CONSUMER_KEY);
  queryParams.append('consumer_secret', CONSUMER_SECRET);
  queryParams.append('per_page', '100');
  
  const url = `${API_URL}/products/categories?${queryParams.toString()}`;
  
  const response = await fetch(url, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  
  if (!response.ok) {
    throw new Error(`Failed to fetch categories: ${response.statusText}`);
  }
  
  return response.json();
}

export async function fetchProductById(id: number): Promise<WooCommerceProduct> {
  const queryParams = new URLSearchParams();
  queryParams.append('consumer_key', CONSUMER_KEY);
  queryParams.append('consumer_secret', CONSUMER_SECRET);
  
  const url = `${API_URL}/products/${id}?${queryParams.toString()}`;
  
  const response = await fetch(url, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  
  if (!response.ok) {
    throw new Error(`Failed to fetch product: ${response.statusText}`);
  }
  
  return response.json();
}
